import { render } from "./Ship.vue?vue&type=template&id=7f1b5e19"
import script from "./Ship.vue?vue&type=script&lang=js"
export * from "./Ship.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/water.jatriweb.team/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__